module.exports = __webpack_public_path__ + "static/media/lower.8b4a387b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/components/SearchGroup/Icon/lower.svg
// module id = 4372
// module chunks = 0